import React from "react";
import BlockRenderer from "./BlockRenderer";

interface BlockData {
    alias: string;
    key: string;
    props?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface DynamicBlocksRendererProps {
    blocks: BlockData[];
}

export const DynamicBlocksRenderer: React.FC<DynamicBlocksRendererProps> = ({ blocks }) => {
    if (!blocks || !blocks.length) return null;

    return (
        <div>
            {blocks.map((block) => {
                // If a block has a "type" property, rename it to sliderType.
                const finalProps = block.props?.type
                    ? { ...block.props, sliderType: block.props.type }
                    : block.props;
                // Pass the adjusted props into BlockRenderer.
                return <BlockRenderer key={block.key} block={{ ...block, props: finalProps }} />;
            })}
        </div>
    );
};
